import styled from 'styled-components';

const CalloutGroupItemTool = styled.span`
	align-items: center;
	display: flex;
	padding-bottom: 0.25rem;
`;

const CalloutGroupItemLogo = styled.img`
	margin-right: 0.5rem;
	width: 1.25rem;
`;

const CalloutGroupItemEmoji = styled.span`
	margin-right: 0.5rem;
`;

export const Styled = {
	CalloutGroupItemTool,
	CalloutGroupItemLogo,
	CalloutGroupItemEmoji,
};
